import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// A protected route that checks if the user is logged in, and redirects to the
// login page if not. Otherwise, it renders the given children.
export const ProtectedRoute = ({ children }) => {
  const { isLoggedIn } = useAuth();
  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }
  return children;
};
